import { SlashCommand } from './types';

export const diaryCommands: SlashCommand[] = [
    {
        id: 'diary-entry',
        trigger: '/diary',
        name: 'My Diary Entry',
        description: 'Draft or retrieve an entry from your My Diary.',
        category: 'LIFESTYLE',
        icon: 'fas fa-book',
        mode: 'prompt',
        integration: 'My Diary'
    }
];
